import { Stack } from "@mantine/core"
import { LabelWithTooltip, Select } from "@tfg/ui"

import { FormFieldConfig } from "~/pages/Admin/components/TypesForm"

export const SelectField = (field: FormFieldConfig, form: any) => (
  <Stack gap="var(--mantine-spacing-xxs)">
    {field.tooltip && (
      <LabelWithTooltip
        label={field.label}
        hoverHelperText={field.tooltip}
        justify="space-between"
        fw={600}
        withAsterisk={field.required ?? false}
      />
    )}
    <Select
      key={field.name}
      label={!field.tooltip ? field.label : undefined}
      placeholder={field.placeholder}
      classNames={field.customClass}
      labelProps={{
        fz: "xs",
        fw: 600,
      }}
      clearable={field.clearable ?? true}
      searchable
      data={
        field.options?.map((data) => ({
          label: data.label,
          value: data.value,
        })) || []
      }
      {...form.getInputProps(field.name)}
      onChange={(value) => {
        form.setFieldValue(field.name, value)
        form.validateField(field.name)
      }}
      error={!form.isValid(field.name) && form.isTouched(field.name)}
      disabled={field.disabled}
    />
  </Stack>
)
